import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/enum/ToasterMessages';
import { ClientService } from 'src/app/shared/services/client.service';

@Component({
  selector: 'legal-edit-schedule-registration',
  templateUrl: './edit-schedule-registration.component.html',
  styleUrls: ['./edit-schedule-registration.component.scss']
})
export class EditScheduleRegistrationComponent implements OnInit, AfterViewInit {

  registerForm!: FormGroup;
  submitted = false;

  clientServiceId!: string;
  scheduleInformation:any;
  @Input() id:string;


  @Output()
  closeModal = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private activeRoute: ActivatedRoute,
    private toasterService: ToastrService,
    private clientService: ClientService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.getById();
  }

  ngAfterViewInit(): void {
  }

  get f() {
    return this.registerForm.controls;
  }

  private initializeForm(): void {
    this.registerForm = this.formBuilder.group({
      scheduledDate: ['', Validators.required],
      amount: [0, Validators.required],
      haveli: [0, Validators.required],
      time: ['', Validators.required]

    });
  }

  getById(){
     this.clientService.getScheduelRegistrationDetailsById(this.id)
    .subscribe((result: any) => {
      this.scheduleInformation = result;

      const scheduledDate = new Date(result.scheduledDate);

      this.registerForm.patchValue({
        scheduledDate: scheduledDate.toISOString().split('T')[0], // yyyy-MM-dd
        time: scheduledDate.toTimeString().substring(0, 5),       // HH:mm
        amount: result.amount,
        haveli: result.haveli
      });

    });
  }


  register(): void {

    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    const requestBody = {
      id: this.id,
      scheduledDate:`${this.registerForm.value.scheduledDate}T${this.registerForm.value.time}`,
      timeSlot:'30',
      amount:
        Number(this.registerForm.value.amount),
      clientServiceId:
        this.clientServiceId,
        haveli:this.registerForm.value.haveli
    };

    this.scheduleRegistration(requestBody);
  }

  private scheduleRegistration(request: any): void {

    this.clientService
      .updateScheduelRegistration(request)
      .subscribe({
        next: () => {

          this.toasterService.success(
            `Registration ${ToasterMessages.Create}`,
            ToasterMessages.SucccessTitle
          );

          this.closeModal.emit(true);
        },

        error: (error) => {

          console.error(error);

          this.toasterService.error(
            error?.error?.message ||
            'Something went wrong',
            ToasterMessages.ErrorTitle
          );
        }
      });
  }

  closePopup(): void {
    this.closeModal.emit(true);
  }
}